<template>
  <div class="Content__DocumentEmpty mx-auto px-5 md:px-0">
    <div class="flex items-center justify-between" v-if="canIApprove">
      <div :class="color" class="text-sm md:text-base font-semibold uppercase cursor-pointer" @click.stop.prevent="click">
        {{ text }}
      </div>
      <div>
        <a href="#approve-or-disapprove" class="text-gray-400"
          ><aw-icon
            icon="chevron-down"
            class="w-4 h-4 "
          />
          {{ $t('Approve') }}</a
        >
      </div>
    </div>
    <div class="flex items-center justify-between cursor-pointer" v-else  @click.stop.prevent="click">
      <div :class="color" class="text-sm md:text-base font-semibold uppercase">
        {{ text }}
      </div>
      <div class="flex items-center">
        <!--<div class="text-gray-400 mr-2">Approved by:</div>-->
        <div class="flex items-center -space-x-2.5">
          <!-- Main visible users -->
          <ui-pictogram
            v-for="user in visibleUsers"
            :key="user.id"
            :user="user.user"
            :class="{ 'text-red-600': user.disapproved, 'text-green-600': user.approved }"
          />
          <!-- rest users -->
          <ui-pictogram
            v-if="restUsersCnt"
            :force-title="restUsersTitle"
            :force-content="restUsersCnt"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import openApproval from '../../mixins/actions/OpenApproval'

export default {
  props: {
    approval: Object,
    document: Object,
    edit: Boolean
  },
  computed: {
    color() {
      switch(this.approval.state) {
        // waiting -> notifications send
        case 'waiting':
          return 'text-bc-blue'
        
        // approved -> all users approved document
        case 'approved':
          return 'text-green-600'
        
        // disapproved -> all users disapproved document
        case 'disapproved':
          return 'text-red-600'
        
        // partially approved -> few users approved, others waiting
        case 'partially-approved':
          return 'text-green-400'
        
        // partially disapproved -> few users disapproved, others waiting
        case 'partially-disapproved':
          return 'text-red-400'
        
        // mostly approved -> most users approved, few dissapproved
        case 'mostly-approved':
          return 'text-green-800'
        
        // mostly disaaproved -> most user disapproved, few approved
        case 'mostly-disapproved':
          return 'text-red-800'
        
        // drawn
        case 'drawn':
          return 'text-bc-blue'

        default:
          return 'text-gray-600'
      }
    },
    text() {
      switch(this.approval.state) {
        // waiting -> notifications send
        case 'waiting':
          return this.$t('Approval request was send and waiting for approval')
        
        // approved -> all users approved document
        case 'approved':
          return this.$t('Approved')
        
        // disapproved -> all users disapproved document
        case 'disapproved':
          return this.$t('Disapproved')
        
        // partially approved -> few users approved, others waiting
        case 'partially-approved':
          return this.$t('Partially approved')
        
        // partially disapproved -> few users disapproved, others waiting
        case 'partially-disapproved':
          return this.$t('Partially disapprove')
        
        // mostly approved -> most users approved, few dissapproved
        case 'mostly-approved':
          return this.$t('Mostly approved')
        
        // mostly disaaproved -> most user disapproved, few approved
        case 'mostly-disapproved':
          return this.$t('Mostly disapproved')
        
        // drawn
        case 'drawn':
          return this.$t('Drawn')

        default:
          // if (this.document.published__bc_document_rev_id !== this.document.bc_document_rev_id) {
            return this.$t('Publish changes to send approval request to approvers')
          // }
      }
    },
    canIApprove() {
      return !this.edit && this.approval.state && this.approval.approvers.filter((u) => u.user.id === this.$presenter.identity.id).length > 0

    },
    visibleUsers() {
      let users = this.approval.approvers.slice(0, 2)
      return users
    },
    restUsers() {
      let users = this.approval.approvers.slice(2)
      return users
    },
    restUsersCnt() {
      return this.restUsers.length
    },
    restUsersTitle() {
      return this.restUsers
        .map(u => {
          return `${u.user.name} ${u.user.surname}`
        })
        .join(', ')
    }
  },
  methods: {
    click() {
      openApproval(this.$store, this.$formValues, this.approval, this.document.id, this.document.bc_document_rev_id, this.edit)
    }
  }
}
</script>

<style lang="scss" scoped></style>
